import type { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: "none";
  variant?: "default" | "surface";
}

export function Card({
  padding,
  variant = "default",
  className = "",
  ...props
}: CardProps) {
  const baseStyles =
    variant === "surface"
      ? "bg-parchment rounded-lg"
      : "bg-white border-[0.5px] border-terroir/20 rounded-lg";
  const paddingStyles =
    padding === "none"
      ? "p-0"
      : variant === "surface"
        ? "px-3.5 py-3"
        : "p-5";

  return <div className={`${baseStyles} ${paddingStyles} ${className}`.trim()} {...props} />;
}
